import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "button"]
  static values = { expanded: Boolean }

  connect() {
    this.expandedValue = false
  }

  toggle(event) {
    if (event) event.preventDefault()
    this.expandedValue = !this.expandedValue

    this.itemTargets.forEach(el => {
      if (this.expandedValue) {
        el.classList.remove("hidden")
        el.classList.add("animate-fade-in")
      } else {
        el.classList.add("hidden")
      }
    })

    if (this.hasButtonTarget) {
      this.buttonTarget.innerHTML = this.expandedValue 
        ? `See Fewer Categories <svg class="h-4.5 w-4.5 inline shrink-0 transition-transform duration-300 rotate-180" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" /></svg>` 
        : `See More Categories <svg class="h-4.5 w-4.5 inline shrink-0 transition-transform duration-300" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" /></svg>`
    }
  }
}
